export default __webpack_public_path__ + "static/media/no-scan.0a00ac7d.svg";